import { lazy } from "react";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { APP_FILE_ADDRESS_HISTORY_ROUTE } from "./AddressHistory.constants";
const AddressHistoryList = Loadable(
  lazy(() =>
    import("./AddressHistoryList").then(({ AddressHistoryList }) => ({
      default: AddressHistoryList,
    }))
  )
);
export const addressHistoryRoutes = [
  {
    path: `${APP_FILE_ADDRESS_HISTORY_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <AddressHistoryList />
      </AuthorizedRoute>
    ),
  },
];
